<template>
  <div v-if="paginationData.meta && paginationData.meta.last_page > 1" class="pagination">
    <ul class="pagination justify-content-center mt-4">
      <li class="page-item" v-bind:class="{ 'disabled': !(paginationData.links && paginationData.links.prev) }">
        <a class="page-link"
           tabindex="-1"
           @click.prevent="$emit('load-prev-page', paginationData.links.prev)">
          <i class="fa fa-lg fa-angle-left"></i>
        </a>
      </li>
      <li v-for="i in (paginationData.meta.links.length - 2)"
          :key="i" class="page-item"
          v-bind:class="{ 'active': paginationData.meta.links[i].active, 'disabled': paginationData.meta.links[i].label === '...' }">
        <a class="page-link"
           @click.prevent="$emit('load-page', paginationData.meta.links[i].url)">
          {{ paginationData.meta.links[i].label }}
        </a>
      </li>
      <li class="page-item" v-bind:class="{ 'disabled': !(paginationData.links && paginationData.links.next) }">
        <a class="page-link"
           @click.prevent="$emit('load-next-page', paginationData.links.next)">
          <i class="fa fa-lg fa-angle-right"></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'Paginator',
    props: {
      paginationData: {
        type: Object,
        default: () => ({}),
      },
    },
  }
</script>
